import dynamic from 'next/dynamic'

const QrScannerWithNoSSR = dynamic(() => import('./QrScanner'), { ssr: false })
export default QrScannerWithNoSSR
